import styled from '@emotion/styled';
import { Radio } from 'antd';

export const ContainerRadio = styled('div')`
  .ant-radio-group {
    width: 324px;
    margin: 20px 0;
    display: flex;
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):first-child {
    border-color: var(--00B86D-antd);
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: var(--00B86D-antd);
    background: var(--FFFFFF-antd);
    border-color: var(--00B86D-antd);
    box-shadow: -1px 0 0 0 var(--00B86D-antd);
  }

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: var(--1FC47D-antd);
    border-color: var(--1FC47D-antd);
    box-shadow: -1px 0 0 0 var(--1FC47D-antd);
  }

  .ant-radio-button-wrapper:hover {
    color: var(--00B86D-antd);
  }
`;

export const RadioGroup = styled(Radio.Group)`
  .ant-radio-group {
    width: 324px;
    margin: 20px 0;
    display: flex;
    border-color: var(--00B86D-antd);
  }

  margin: 20px 0;
`;

export const RadioButton = styled(Radio.Button)`
  .ant-radio-group {
    width: 324px;
    margin: 20px 0;
    display: flex;
    border-color: var(--00B86D-antd);
  }
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.25px;
  width: min-content;
  flex: 1;
  white-space: nowrap;
  padding: 0 8px;
`;

export const ErrorText = styled('span')`
  color: var(--FF5F5F-modals-transfer-profile);
  font: 400 10px/16px 'Roboto';
  display: flex;
`;

export const ConfirmTitleText = styled('span')`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-left: 1px;
  margin-bottom: 0;

  color: var(--222222-modals-transfer-profile);
`;

export const ConfirmContentText = styled('p')`
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;

  color: var(--767676-modals-transfer-profile);
`;

export const ConfirmBlock = styled('div')`
  line-height: 1.4;
  margin-left: 42px;
  padding-bottom: 14px;
`;

export const ConfirmButton = styled('div')`
  line-height: 1.5;
  display: inline-block;
  font-weight: 400;
  white-space: nowrap;
  text-align: center;
  background-image: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  user-select: none;
  touch-action: manipulation;
  height: 32px;
  font-size: 14px;
  border-radius: 4px;
  outline: 0;
  color: var(--000000A6-antd);
  background-color: var(--FFFFFF-antd);
  border: 1px solid var(--D9D9D9-antd);
  padding: 6px 12px;
  
  :hover {
    color: var(--1FC47D-antd-button-text);
    background-color: var(--FFFFFF-antd);
    border-color: var(--1FC47D-antd-button-text);
  }
`;

export const CancelButton = styled(ConfirmButton)`
  color: var(--FFFFFF-antd);
  background-color: var(--00B86D-antd);
  border-color: var(--00B86D-antd);
  
  :hover {
    color: var(--FFFFFF-antd);
    background-color: var(--1FC47D-antd);
    border-color: var(--1FC47D-antd);
  }
`;

export const transferOkButtonProps: ButtonProps = {
  type: 'primary',
  style: { padding: '0 13px', position: 'absolute', bottom: 23, right: 29 },
};

export const transferCancelButtonProps: ButtonProps = {
  type: 'default',
  style: { padding: '0px 11px 0 14px', position: 'absolute', bottom: 23, right: 110 },
};
